import { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { AnswerValue, CardI } from '~src/interfaces/question.interface';
import { ButtonShape, ButtonSizes } from '~src/shared/buttons/basicButtons/BaseButton.sc';

import {
  ArrowWrapper,
  CenteredNoAnswerContainer,
  NavArrow,
  NavContainer,
  NoAnswerButton,
  ProgressBar,
  ProgressBarContainer,
  RightNoAnswerContainer,
} from './cardNavigation.sc';

interface Props {
  max: number;
  value: number;
  next: () => void;
  back?: () => void;
  card?: CardI;
  onSubmit?: (values: AnswerValue, currentCard: CardI) => Promise<void>;
}

interface State {
  showArrows: boolean;
}

class CardNavigation extends Component<Props & WithTranslation, State> {
  state = {
    showArrows: false,
  };

  toggleArrows = () => {
    this.setState((prevState) => ({ showArrows: !prevState.showArrows }));
  };

  calcProgressWidth = () => {
    if (this.props.max !== 1) {
      return ((this.props.value - 1) / (this.props.max - 1)) * 100;
    }
    return 0;
  };

  sendEmptyAnswer = () => {
    if (this.props.card && this.props.onSubmit) {
      this.props.onSubmit({ comment: null, rating: null }, this.props.card).then(() => {
        this.props.next();
      });
    }
  };

  render() {
    const backDisabled = this.props.value === 1 || !this.props.back;
    const answeredWithoutRating = !!(
      this.props.card &&
      this.props.card.answer &&
      this.props.card.answer.answeredAt &&
      !this.props.card.answer.multipleChoiceAnswers?.length &&
      this.props.card.answer.answer === null
    );
    return (
      <NavContainer>
        {this.props.card && !this.props.card.mandatory && (
          <CenteredNoAnswerContainer>
            <NoAnswerButton
              style={{ marginLeft: 'auto', marginRight: 'auto' }}
              onClick={this.sendEmptyAnswer}
              $buttonShape={ButtonShape.Rectangle}
              $buttonSize={ButtonSizes.Tiny}
              $withBorder
              $highlighted={answeredWithoutRating}
            >
              {this.props.t('x.questionstream.navbar.cannot_answer')}
            </NoAnswerButton>
          </CenteredNoAnswerContainer>
        )}
        <ArrowWrapper>
          <div onClick={!backDisabled ? this.props.back : undefined}>
            <NavArrow name="iconArrow" $left $disabled={backDisabled} />
          </div>
        </ArrowWrapper>
        <ProgressBarContainer onClick={this.toggleArrows}>
          <ProgressBar $width={this.calcProgressWidth()} />
        </ProgressBarContainer>
        <ArrowWrapper onClick={this.props.next}>
          <NavArrow name="iconArrow" />
        </ArrowWrapper>
        {this.props.card && !this.props.card.mandatory && (
          <RightNoAnswerContainer>
            <NoAnswerButton
              onClick={this.sendEmptyAnswer}
              $buttonShape={ButtonShape.Rectangle}
              $buttonSize={ButtonSizes.Tiny}
              $withBorder
              $highlighted={answeredWithoutRating}
            >
              {this.props.t('x.questionstream.navbar.cannot_answer')}
            </NoAnswerButton>
          </RightNoAnswerContainer>
        )}
      </NavContainer>
    );
  }
}

const CardNavigationT = withTranslation()(CardNavigation);
export default CardNavigationT;
